import { FC } from 'react'

import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Box } from '../../../shared_components/UI/Box'
import { IPool } from '../../../types/reducerTypes'
import { getRgbaValue } from '../../../utils/styling/getRgbaValue'
import { Title } from '../../Home/parts'
import { BoxSubHeading } from '../parts'

// import EmailSignup from '../SwapBox/EmailSignup'
import FAQ from './FAQ'
import { Container, Section } from './styles'
import { ThemedButton } from '../../../shared_components/ThemedButton'
import routes from '../../../router/routes'
import { selectIsEthRaise } from '../../../modules/web3/selectors'
import { useSelector } from 'react-redux'

interface Props {
  pool: IPool
  investAmount: number
  isLabsPool: boolean
}

const Rocket = styled.img`
  position: absolute;
  top: 0;
  right: 0;
`

const TopTable = styled(Box)<{ noBottomBorder?: boolean }>`
  border-top: 1px solid
    ${({ theme }) => getRgbaValue(theme.semantics.zap.surface.primary, 0.2)};

  ${({ noBottomBorder, theme }) =>
    !noBottomBorder &&
    `
    border-bottom: 1px solid ${getRgbaValue(
      theme.semantics.zap.surface.primary,
      0.2,
    )};
  `}

  padding: 32px 0;
  position: relative;
`

const PoolLogo = styled.img`
  border-radius: 250px;
  width: 64px;
  height: 64px;
  margin-right: 16px;
`

const Subtitle = styled.span`
  font-family: 'Space Grotesk';
  font-size: 24px;
  line-height: 32px;
  text-transform: uppercase;
`

const SubBox = styled(Box)`
  max-width: 140px;
  margin-bottom: 16px;
`

const Desktop = styled.div`
  @media screen and (max-width: 1400px) {
    ${Rocket} {
      transform: scale(0.9);
      transform-origin: right;
      right: -80px;
    }
  }
  @media (max-width: 1000px) {
    display: none;
  }
`
const Mobile = styled.div`
  ${Rocket} {
    position: relative;
    margin-top: -80px;
  }
  @media (min-width: 1000px) {
    display: none;
  }
`

const ValuesHolder = styled(Box)`
  @media screen and (max-width: 1000px) {
    flex-direction: column;
  }
`

const InvestmentCompleted: FC<Props> = ({ pool, investAmount, isLabsPool }) => {
  const POOL_LOGO = (pool as any)?.about?.logo?.url ?? ''
  const isEthRaise = useSelector(selectIsEthRaise)

  return (
    <>
      <Container>
        <Mobile>
          {/* <Rocket src="/img/rocket.gif" alt="rocket gif" /> */}
        </Mobile>
        <Title maxWidth={737} uppercase>
          Token Purchase completed
        </Title>
        <Section noBorder>
          <Box direction="column" marginBottom={32}>
            <TopTable noBottomBorder>
              <Box dc g={16}>
                <Box justify="flex-start">
                  <PoolLogo src={POOL_LOGO} alt="pool logo" />
                  <Box direction="column">
                    <ValuesHolder>
                      <SubBox direction="column">
                        <BoxSubHeading>Invested In</BoxSubHeading>
                        <Subtitle>${pool.ticker}</Subtitle>
                      </SubBox>
                      <SubBox direction="column">
                        <BoxSubHeading>Invested Amount</BoxSubHeading>
                        <Subtitle>
                          {investAmount} {isEthRaise ? 'ETH' : 'USDB'}
                        </Subtitle>
                      </SubBox>
                    </ValuesHolder>
                  </Box>
                </Box>
                <Box dc g={16}>
                  <p>
                    Your tokens will be claimable in the your dashboard at the
                    first vesting point.{' '}
                  </p>
                  <Box gap={20}>
                    <Link to={`/fundraise/${pool.slug}`}>
                      <ThemedButton $styleType="primary">
                        Purchase more
                      </ThemedButton>
                    </Link>

                    <Link
                      to={isLabsPool ? routes.labs.index : routes.launch.pools}
                    >
                      <ThemedButton $styleType="primary">
                        Browse other projects
                      </ThemedButton>
                    </Link>
                  </Box>
                </Box>
              </Box>
            </TopTable>
          </Box>
          {/* <p>
            Drop us your email to get notified when your tokens are ready to
            claim
          </p>
          <EmailSignup narrowButton /> */}
        </Section>
        <FAQ isBlock />
      </Container>
      <Desktop>
        {/* <Rocket src="/img/rocket.gif" alt="rocket gif" /> */}
      </Desktop>
    </>
  )
}

export default InvestmentCompleted
